<div class="flex flex-row justify-center">
  <h1>{{ 'pageNotFound' | translate }}</h1>
</div>
